export default __webpack_public_path__ + "static/media/filtering_transactions.10544b6b.png";